/**
 * Track which customer chat threads are currently expanded in the admin panel.
 * Multiple CSR dock windows can be open at once (Messenger-style).
 */
function ids() {
  if (typeof window === "undefined") return null;
  if (!window.__naseebiOpenChatIds) {
    window.__naseebiOpenChatIds = new Set();
  }
  return window.__naseebiOpenChatIds;
}

function syncLegacySingle() {
  if (typeof window === "undefined") return;
  const set = ids();
  const last = set && set.size ? [...set][set.size - 1] : null;
  window.__naseebiOpenChatId = last;
}

export function registerOpenAdminChatId(chatId) {
  if (chatId == null) return;
  const set = ids();
  if (!set) return;
  set.add(String(chatId));
  syncLegacySingle();
}

export function unregisterOpenAdminChatId(chatId) {
  if (chatId == null) return;
  const set = ids();
  if (!set) return;
  set.delete(String(chatId));
  syncLegacySingle();
}

export function isAdminChatOpen(chatId) {
  if (chatId == null || typeof window === "undefined") return false;
  const set = window.__naseebiOpenChatIds;
  if (set?.has(String(chatId))) return true;
  return (
    window.__naseebiOpenChatId != null &&
    String(window.__naseebiOpenChatId) === String(chatId)
  );
}
